'use strict';

const Mn = require('backbone.marionette');
const Moment = require('moment');
const Template = require('common/ui/template/header/license.hbs');

module.exports = Mn.View.extend({
    tagName: 'span',
    template: Template,

    templateContext: function() {
        const now = Moment();
        const expired = this.model.getDeactivatedAt() < now;
        let lastDays = this.model.getDeactivatedAt().diff(now, 'days');

        return {
            target: this.model.getTarget(),
            type: this.model.getType(),
            isTrial: this.model.getType() == 'trial',
            isAcademic: this.model.getType() == 'academic',
            deactivatedAt: this.model.getDeactivatedAt(),
            autoRenewal: this.model.isAutoRenewal(),
            lastDays: lastDays,
            showLastDays: lastDays < 60,
            expired: expired
        };
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/header/license.js